import React from "react";
import PropTypes from "prop-types";
import Heading from "../../elements/heading";
import PrimaryLink from "../../elements/primary-link";
import BodyText from "../../elements/body-text";
import "./style.scss";
const MembershipOverview = ({ titleType, titleBody, overview, match, link }) => {
  return (
    <div className="membership-overview">
      {titleBody && (
        <div className="membership-heading">
          <Heading type={titleType} html={titleBody} typographyClass="type-h3" />
        </div>
      )}
      <div className="membership-overview-container">
        <div className="membership-overview-heading">
          <Heading type={overview?.headingType} html={overview?.heading} />
        </div>
        {overview?.subheading && <div className="membership-overview-subheading">{overview?.subheading}</div>}
        <div className="membership-overview-body">
          {overview.renewDate && <BodyText html={`${overview?.body} ${overview.renewDate}`} />}
          <div>{overview?.membershipFee}</div>
          <div className="membership-overview-link">{link && <PrimaryLink {...link.fields} />}</div>
        </div>
      </div>
    </div>
  );
};

MembershipOverview.propTypes = {
  titleType: PropTypes.object,
  titleBody: PropTypes.object,
  overview: PropTypes.shape({
    heading: PropTypes.object,
    body: PropTypes.string,
    renewDate: PropTypes.string,
    membershipFee: PropTypes.string,
    currency: PropTypes.string
  })
};

export default MembershipOverview;
